var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-layout text-center mt-4"},[_c('h1',[_vm._v(_vm._s(_vm.$t('error_alert_title')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('error_alert_text')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }